import {createAction} from '@reduxjs/toolkit';
import {
  SET_PAYMENTS,
  SET_PAYMENTS_PAGINATION,
} from '@crema/types/actions/Payment.action';

export const SetPayments = createAction<any[]>(SET_PAYMENTS);
export const SetPaymentsPagination = createAction<{
  count: number;
  pages: number;
}>(SET_PAYMENTS_PAGINATION);
